"use client";
import { jsx as e } from "react/jsx-runtime";
import { ModalPrimitive as a } from "@inkeep/cxkit-primitives";
import { cn as s } from "../utils.js";
import { button as n } from "../ui/recipes/button.js";
import { modal as l } from "../ui/recipes/modal.js";
const p = a.Modal, x = ({
  className: t,
  ...o
}) => /* @__PURE__ */ e(a.Overlay, { className: s(l({ slot: "overlay" }), t), ...o }), v = ({
  className: t,
  ...o
}) => /* @__PURE__ */ e(
  a.Content,
  {
    className: s(
      l({ slot: "content" }),
      "w-[min(90vw,720px)]",
      // Dual pane
      "has-[[data-dual-pane-search-expanded]]:w-[min(90vw,1000px)] transition-width duration-300",
      t
    ),
    ...o
  }
), h = ({
  className: t,
  ...o
}) => /* @__PURE__ */ e(
  a.Close,
  {
    className: s(
      l({ slot: "close" }),
      n({ variant: "ghost", size: "xs" }),
      "relative inset-[unset] ml-auto text-lg text-gray-500 dark:text-white-alpha-500 px-0",
      "md:hidden",
      t
    ),
    ...o
  }
);
export {
  h as Close,
  v as Content,
  x as Overlay,
  p as Root
};
